import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { getActiveSpace } from 'spaces/index';
import {
  getActivePathStringWithSpace,
  getEditingFolder,
} from 'documents/store/folders/selectors';
import { getActiveDocument } from 'documents/store/documents/selectors';
import { closeModal } from 'modal/store/actions';
import Title3 from 'base/components/Title3';
import MainTitle from 'base/components/MainTitle';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import SubmitButton from 'base/components/forms/SubmitButton';
import ModalHeader from 'modal/components/ModalHeader';
import { getEntities } from '../../../store/entities/selectors';
import { cacheDocumentOffline } from '../../store/actions';

const DocumentCacheOfflineModal = ({
  name, closeModal, cacheDocumentOffline, activePathString, activeDocument,
}) => (
  <>
    <ModalHeader>
      <MainTitle>
        Save document offline:
        {' '}
        <br />
        <strong>Password required</strong>
      </MainTitle>
    </ModalHeader>

    <FieldWrapper>
      <div>{activePathString}</div>
      <Title3>{activeDocument.name}</Title3>
    </FieldWrapper>

    <FieldWrapper>
      You have to unlock this document in order to save it for offline usage.
      Please enter the password in the field below.
    </FieldWrapper>

    <Formik
      initialValues={{
        password: '',
      }}
      validationSchema={
        Yup.object().shape({
          password: Yup.string()
            .required('PDF password is required.'),
        })
      }
      render={({errors, isSubmitting}) => ( // eslint-disable-line
        <Form>
          <Field
            type="password"
            name="password"
            placeholder="PDF password"
            component={FormikInputField}
            autoFocus
          />
          <SubmitButton type="submit" disabled={isSubmitting}>
              Save offline
          </SubmitButton>
        </Form>
      )}
      onSubmit={(values) => {
        closeModal(name);
        cacheDocumentOffline(activeDocument, values.password);
      }}
    />
  </>
);
DocumentCacheOfflineModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.object.isRequired, // eslint-disable-line
  folder: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  cacheDocumentOffline: PropTypes.func.isRequired,
  activePathString: PropTypes.string.isRequired,
  activeDocument: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
  folder: getEditingFolder(state),
  activePathString: getActivePathStringWithSpace(state),
  entities: getEntities(state),
  activeDocument: getActiveDocument(state),
});

const mapDispatchToProps = {
  cacheDocumentOffline,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentCacheOfflineModal);
